<template>
  <div>
    <div vs-lg="4" vs-sm="8" vs-xs="8" class="flex flex-col justify-center">
      <p class="headerstyle">เพิ่มประเภทผู้เรียน</p>
      <div class="fromstyle">
        <form @submit.prevent="checkForm">
          <div v-if="errors.length">
            <b>กรุณากรอกข้อมูลให้ถูกต้อง :</b>
            <ul>
              <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </div>
          <vs-input
            class="w-full"
            id="organization"
            placeholder="ชื่อประเภทผู้เรียน"
            type="text"
            v-model="organization"
            name="organization"
            required
          />

          <br />
          <vs-textarea
            label="รายละเอียดประเภทผู้เรียน"
            height="100%"
            v-model="description"
          />

          <vs-row vs-w="12">
            <vs-col vs-w="12" class="flex justify-center">
              <button type="submit" value="Submit" class="share-btn px-16">
                เพิ่ม
              </button>
            </vs-col>
          </vs-row>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../../../util/backend";
import baseUrl from "../../../util/baseUrl";

export default {
  methods: {
    async checkForm(e) {
      if (this.organization) {
        this.$vs.loading();
        let config = {
          method: "post",
          url: `${baseUrl.baseurl()}/createOrganization`,
          data: {
            name: this.organization.trimLeft(),
            desc: this.description
          }
        };

        await axios
          .api(config)
          .then(res => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "การสร้างประเภทหน่วยงาน",
              text: "สำเร็จ",
              color: "success",
              icon: "check_box",
              position: "top-right"
            });
            this.$router.push({ path: "/organization" });
          })
          .catch(error => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error message",
              text: `${
                error.response.data.error ? error.response.data.error : error
              }`,
              color: "danger",
              icon: "error",
              position: "top-right"
            });
          });
      }

      this.errors = [];

      if (!this.organization) {
        this.errors.push("กรุณากรอกชื่อประเภทหน่วยงาน");
      }
    }
  },

  mounted() {},
  data() {
    return {
      organization: null,
      description: null,
      errors: []
    };
  },
  computed: {
    ...mapGetters({})
  }
};
</script>

<style lang="scss" scoped>
.fromstyle {
  padding: 0;
}

.share-btn {
  background-color: #0430ad;
  padding: 10px 20px 10px 20px;
  border-radius: 10px;
  border-style: none;
  color: #ffff;

  &:hover {
    transition-delay: 100ms;
    background-color: #072c49;
  }
  &:active {
    background-color: #072c49;
  }
}

.headerstyle {
  color: #1a3683;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  text-align: center;
}
</style>
